/**
 * User: hella
 * Date: 3/31/14
 * Time: 1:06 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';
var $ = require('dibs-jquery-shim');
var priceMixins;

priceMixins = {
    _priceClasses: {
        wrapper: '.product-price',
        link: '.product-price-item',
        label: '.product-price-labels',
        visible: '.is-visible',
        invisible: '.is-invisible',
        loggedIn: '.is-logged-in',
        sold: '.is-sold',
        hold: '.is-on-hold'
    },
    _priceOptions: {},
    _currency: {
        defaultCurrency: "USD"
    },
    CONSTANTS: {
        PRICE_HIDDEN: 'Price Upon Request',
        PRICE_SOLD: 'sold'
    },
    _ensurePriceTextVisible : function () {
        var wrapperClass = this._priceClasses.wrapper;
        var invisibleClass = this._priceClasses.invisible;
        this.$el.find(wrapperClass + invisibleClass).removeClass(invisibleClass.substring(1));
    },
    setPriceOptions: function (options) {
        $.extend(this._priceClasses, options.classes);
        delete options.classes;
        $.extend(this._priceOptions, options);
    },
    hidePrices : function () {
        var linkClass = this._priceClasses.link;
        var visibleClass = this._priceClasses.visible;
        var loggedInClass = this._priceClasses.loggedIn;
        this.$el.find(linkClass + loggedInClass).each(function () {
            $(this).removeClass().addClass(linkClass.substring(1)).text('View Price')
                .parent().children('span').removeClass(visibleClass.substring(1));
        });
        return this;
    },
    showPrices : function (currencyPref) {
        var linkClass = priceMixins._priceClasses.link;
        var visibleClass = priceMixins._priceClasses.visible;

        currencyPref = currencyPref || priceMixins._currency.defaultCurrency;

        this.$el.off('click', linkClass).on('click', linkClass, function () {
            return false;
        });
        this.$el.find(linkClass).each(function (i, priceEl) {
            var $priceEl = $(priceEl);
            var priceData = $priceEl.data(currencyPref.toLowerCase());
            var isSold = $priceEl.data('sold');
            var isHidden = $priceEl.data('hide-price');
            var elClass = '';

            // jQuery data can return any JS data type, to be safe we only cast numbers to strings
            if (typeof priceData === 'number') {
                priceData = priceData.toString();
            }

            if (isSold) {
                elClass = ' ' + priceMixins._priceClasses.sold.substring(1);
                priceData = priceMixins.CONSTANTS.PRICE_SOLD;
            } else if (isHidden) {
                priceData = priceMixins.CONSTANTS.PRICE_HIDDEN;
            }

            $priceEl
                .text(priceData)
                .addClass(elClass)
                .parent()
                .children('span')
                .addClass(visibleClass.substring(1));
        });
        return this;
    },
    /**
     * Show/hide prices
     * @param {boolean} showPrices `true`: show the prices to the user, `false`: hides prices
     * @param {string} currencyPref The user's currency preference
     * @returns {boolean}
     */
    updatePrices: function (showPrices, currencyPref) {
        if (!showPrices) {
            this.hidePrices()._ensurePriceTextVisible();
            return false;
        }
        this.showPrices(currencyPref)._ensurePriceTextVisible();
        // HACK: This is for use in the new PDP and should ultimately be replaced by a Fluxible action.
        $.publish('update-currency', currencyPref);
        return true;
    },

    /**
     * Show/hide price labels. Currently only used on s/b pages.
     */
    showLabels: function () {
        var labelClass = this._priceClasses.label;
        var invisibleClass = this._priceClasses.invisible;
        var priceLabels = $(labelClass);
        if (priceLabels.length) {
            priceLabels.removeClass(invisibleClass.substring(1));
        }
    }
};

module.exports = priceMixins;



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/mixins/commonjs/price.js
// module id = 936
// module chunks = 64